import * as React from 'react';
import { DoubleCheck } from './DoubleCheck';
import arrow from '../../../../assets/images/static_pages/arrow_down.svg';

export const FeaturesMatrix = () => {
  const [showMatrix, setShowMatrix] = React.useState(false);
  const coreFunctionalityFeatures = [
    { title: 'Starting Number of Seats', check_count: 0, numbers: [1, 1, 1] },
    { title: 'Starting Number of Phone Numbers', check_count: 0, numbers: [1, 1, 1] },
    { title: 'Unlimited Live Chat Messages', check_count: 3 },
    { title: 'Customizable Website Widget', check_count: 3 },
  ];

  const marketingFeatures = [
    { title: 'Unlimited Keywords', check_count: 3 },
    { title: 'Unlimited Contacts', check_count: 3 },
    { title: 'Contact Exporting via CSV', check_count: 3 },
    {
      title: 'Unlimited Customizable Fields',
      check_count: 3,
      hover_state: {
        title: 'Unlimited Customizable Fields',
        content: 'Save any contact data directly within Avochato using our custom fields. You can insert that data automatically into messages to create personalized experiences over text.',
      },
    },
    { title: 'Personalized Messages', check_count: 3 },
    {
      title: 'Broadcast Messages',
      check_count: 2,
      hover_state: {
        title: 'Broadcast Messages',
        content: 'Broadcasting allows you to send bulk messages with personalization to many contacts at once.',
      },
    },
    { title: 'Drip Campaigns', check_count: 2 },
    { title: 'Surveys', check_count: 2 },
  ];

  const supportFeatures = [
    { title: 'User Roles and Management', check_count: 3 },
    { title: 'Templates / Automatic Replies', check_count: 3 },
    { title: 'Conversation Disposition Logging', check_count: 2 },
    { title: 'Skill Routing', check_count: 2 },
    { title: 'Advanced Agent Reporting and Analytics', check_count: 2 },
  ];

  const integrationFeatures = [
    { title: 'Contact Opt In/Out Webhooks', check_count: 3 },
    { title: 'Inbound/Outbound Message Webhooks', check_count: 3 },
    { title: 'Website Widget Submission Webhooks', check_count: 3 },
    {
      title: 'Salesforce Embedded Widget',
      check_count: 3,
      hover_state: {
        title: 'Salesforce Embedded Widget',
        content: 'Each Salesforce widget user requires an additional $10 license.',
      },
    },
    { title: 'Salesforce Data Syncing', check_count: 2 },
    { title: 'Salesforce Process Builder + Advanced Functionality', check_count: 2, contact_us: true },
    { title: 'Survey Completion Webhooks', check_count: 2 },
    { title: 'Zapier', check_count: 2 },
    { title: 'Microsoft Teams Integration', check_count: 2 },
    { title: 'Slack Integration', check_count: 2 },
    { title: 'API Integrations', check_count: 2, contact_us: true },
  ];

  const coreFunctionalityFeaturesComponents = coreFunctionalityFeatures.map(
    (feature, idx) => <DoubleCheck key={feature.title} feature={feature} idx={idx} />,
  );
  const marketingFeaturesComponents = marketingFeatures.map(
    (feature, idx) => <DoubleCheck key={feature.title} feature={feature} idx={idx} />,
  );
  const supportFeaturesComponents = supportFeatures.map(
    (feature, idx) => <DoubleCheck key={feature.title} feature={feature} idx={idx} />,
  );
  const integrationFeaturesComponents = integrationFeatures.map(
    (feature, idx) => <DoubleCheck key={feature.title} feature={feature} idx={idx} />,
  );

  return (
    <>
      <h3
        id="matrix-toggle"
        className="bold-600 center pt-20"
        onClick={() => setShowMatrix(!showMatrix)}
      >
        See Full Features Matrix
        &nbsp;
        <span className="arrow">
          <img className={showMatrix ? 'flip' : ''} src={arrow} alt="arrow" />
        </span>
      </h3>
      <table className={`features-matrix ${showMatrix ? '' : 'hide'}`}>
        <tbody>
          <tr>
            <th className="header">Core Functionality</th>
            <th style={{ fontWeight: 800 }}>Lite</th>
            <th style={{ fontWeight: 800 }}>Standard</th>
            <th style={{ fontWeight: 800 }}>Custom</th>
          </tr>
          {coreFunctionalityFeaturesComponents}
          <tr><th className="header">Marketing Functionality</th></tr>
          {marketingFeaturesComponents}
          <tr><th className="header">Support Features</th></tr>
          {supportFeaturesComponents}
          <tr><th className="header">Integration Features</th></tr>
          {integrationFeaturesComponents}
        </tbody>
      </table>
    </>
  );
};
